import i18n from "i18next"
import Backend from 'i18next-xhr-backend'
import LanguageDetector from 'i18next-browser-languagedetector'
import { initReactI18next } from 'react-i18next'

const queryStringParams = {}

if (process.env.GATSBY_CI_COMMIT_SHORT_SHA) {
  queryStringParams.v = process.env.GATSBY_CI_COMMIT_SHORT_SHA;
}

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'nl',
    detection: {
      order: ['path']
    },
    whitelist: ['nl', 'en'],
    lowerCaseLng: true,
    load: 'languageOnly',
    // have a common namespace used around the full app
    debug: false,
    interpolation: {
      escapeValue: false, // not needed for react!!
    },
    react: {
      useSuspense: true,
    },
    backend: {
      queryStringParams
    }
  })

export default i18n
